'use strict';

import { useSelector } from 'react-redux';
import { TrackingConstants } from '../cfs-search-slice';

import analytics from '../../../../utils/analytics';

export const SearchType = ({ isNew }) => {
	const targetUrl = useSelector((state) => state.cfsSearch.filterState.switchSearchTypeUrl);

	const onClick = (e) => {
		analytics.trackEvent(TrackingConstants.Categories.TypeToggled, `Switch to ${isNew ? 'Used' : 'New'}`, targetUrl);
	};

	let switches;

	if (isNew) {
		switches = (
			<div className="toggle-switch">
				<span className="toggle-switch__label toggle-switch__label--active">New cars</span>

				<a href={targetUrl} onClick={onClick} className="toggle-switch__switch">
					<span className="toggle-switch__switch__slider toggle-switch__switch__slider--left"></span>
				</a>

				<a href={targetUrl} onClick={onClick} className="toggle-switch__label">Used cars</a>
			</div>
		);
	} else {
		switches = (
			<div className="toggle-switch">
				<a href={targetUrl} onClick={onClick} className="toggle-switch__label">New cars</a>

				<a href={targetUrl} onClick={onClick} className="toggle-switch__switch">
					<span className="toggle-switch__switch__slider toggle-switch__switch__slider--right"></span>
				</a>

				<span className="toggle-switch__label toggle-switch__label--active">Used cars</span>
			</div>
		);
	}

	return (
		<div className="search-filters__search-type">
			{switches}
		</div>
	);
}